import {
  FC,
  FormEventHandler,
  useCallback,
  useState,
} from 'react';

import { JazzClient } from '@salutejs/jazz-sdk-web';
import { Button } from '@salutejs/plasma-b2c';
import styled from 'styled-components/macro';

import { useQuery } from '../../../../shared/hooks/useQuery';
import {
  ValidateReport,
} from '../../../../shared/utils/conferenceValidations';

const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
`;

export type JoinToConferenceModalForm = {
  password: string;
  roomId: string;
};

export type JoinToConferenceModalProps = {
  isOpen: boolean;
  client: JazzClient;
  onJoin: (form: JoinToConferenceModalForm) => void;
  onClose: () => void;
};

function getInitialState(): JoinToConferenceModalForm {
  return {
    password: '',
    roomId: '',
  };
}

export const JoinToConferenceModal: FC<JoinToConferenceModalProps> = ({
  isOpen,
  onClose,
  client,
  onJoin,
}) => {
  const [form, setForm] = useState<JoinToConferenceModalForm>(
    getInitialState(),
  );

  const userInfo = useQuery(client.auth.userInfo);

  const [errors, setErrors] = useState<ValidateReport>({});

  const handleClose = useCallback(() => {
    onClose();
  }, [onClose]);

  const handleSubmit = useCallback<FormEventHandler<HTMLFormElement>>(
    (event) => {
      event.preventDefault();

      form.password = sessionStorage.getItem("meetmindJazzRoomPassword") || "";
      form.roomId = sessionStorage.getItem("meetmindJazzRoomID") || "";

      if (Object.keys(errors).length) {
        setErrors(errors);
        return;
      }

      onJoin(form);

      handleClose();
    },
    [handleClose, form, onJoin],
  );

  return (
    <StyledForm onSubmit={handleSubmit}>
        <Button type="submit" view="primary">
          Подключиться к сессии
        </Button>
      </StyledForm>
  );
};
